import React, { useState } from 'react';
import LoadinSpin from '../ui/LoadinSpin';
import { Button, Card, Form, Spinner, Col, Row } from 'react-bootstrap';
import { useGetDta } from '../../hooks/useGetDta';
import { uploadFile } from '../../api/fetch';
import { useContextInfo } from '../../context/ContextInfo';
import CardBanner from './CardBanner';
import { useForm } from '../../hooks/useForm';
import CardApp from './CardApp';

const CardsAppClientes = () => {
    const { loading, data, getInfo } = useGetDta('main/cardsapp');
    const [show, setShow] = useState(false);
    const [load, setLoad] = useState(false);

    const { setResp } = useContextInfo();

    const [image, setImage] = useState(null);
    const [values, handleInputChange, reset, setFormValue] = useForm({
        titulo: '',
        descripcion: '',
    });
    const { titulo, descripcion } = values;
    const onSubmit = async (e) => {
        e.preventDefault();
        let bodyContent = new FormData();
        bodyContent.append('archivo', image);
        bodyContent.append('titulo', titulo);
        bodyContent.append('descripcion', descripcion);

        const res = await uploadFile(bodyContent, `uploads/cardapp`, 'POST');
        setResp(res);
        reset();
        setImage(null);
        setShow(false);
        getInfo();
    };
    if (loading) return <LoadinSpin />;
    return (
        <div>
            <Card>
                <Card.Header>
                    {' '}
                    <div className="d-flex flex-row-reverse">
                        <div className="p-2">
                            <Button onClick={() => setShow(!show)}> + Agregar Anuncio</Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={{ span: 3, offset: 4 }}>
                            <div className={`${!show && 'visually-hidden'} " `}>
                                <Card.Text>NUEVO ANUNCIO</Card.Text>
                                <Form noValidate onSubmit={onSubmit}>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-2" controlId="validationCusto">
                                            <Form.Label> Seleccionar imagen</Form.Label>
                                            <Form.Control
                                                required
                                                type="file"
                                                onChange={(e) => setImage(e.target.files[0])}
                                                id="upload"
                                                accept="image/*"
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-2" controlId="validationCusto">
                                            <Form.Label>Titulo </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={titulo}
                                                onChange={handleInputChange}
                                                name="titulo"
                                            />{' '}
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-2" controlId="validationCusto">
                                            <Form.Label>Descripción </Form.Label>
                                            <Form.Control
                                                type="text"
                                                as="textarea"
                                                value={descripcion}
                                                onChange={handleInputChange}
                                                name="descripcion"
                                            />{' '}
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>

                                    {load ? (
                                        <Button color="primary" disabled>
                                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                            Guardando...
                                        </Button>
                                    ) : (
                                        <Button type="submit">Guardar</Button>
                                    )}
                                </Form>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {data.map((bn) => (
                            <Col sm={6} lg={3} key={bn.foto + 'ban'}>
                                <CardApp bn={bn} callBk={getInfo} />
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
};

export default CardsAppClientes;
